import _get from 'lodash/get';

export const getCurrentSectionCode = state => state.layout.currentSectionCode;

export const getNavigationSection = state => getCurrentSectionCode(state);

export const getRequestedEntityType = state => state.layout.requestedEntityType;

export const getRequestedEntityId = state => state.layout.requestedEntityId;

export const getLayoutById = (state, entity, id) => {
  const section = getCurrentSectionCode(state);

  return _get(state, `layout.${section}.${entity}.${id}`, null);
};

export const getCurrentLayout = state => {
  const entityType = getRequestedEntityType(state);
  const entityId = getRequestedEntityId(state);

  return getLayoutById(state, entityType, entityId);
};

export const getLayoutNavigation = state => {
  const section = getCurrentSectionCode(state);

  return _get(state, `layout.${section}.navigation`, null);
};

export const getCurrentBlockPagination = (state, entityType, entityId, blockIndex) =>
  _get(
    state,
    `layout.${getCurrentSectionCode(state)}.${entityType}.${entityId}.blocks.${blockIndex}.content.pagination`,
  );

export const getCurrentBlockItems = (state, entityType, entityId, blockIndex) =>
  _get(state, `layout.${getCurrentSectionCode(state)}.${entityType}.${entityId}.blocks.${blockIndex}.content.items`);

export const getCurrentLayoutDimensions = state => {
  const entityId = getRequestedEntityId(state);
  const entityType = getRequestedEntityType(state);
  const currentSectionCode = getCurrentSectionCode(state);

  return _get(state, `layout.${currentSectionCode}.${entityType}.${entityId}.analytics.googleAnalytics`, null);
};

export const getContentTemplatesOptions = state => _get(state, 'layout.contentTemplatesOptions', null);
